<div class="badge">
  <span class="badge__dot" [style.backgroundColor]="color"></span>
  <span class="badge__text">{{ text }}</span>
</div>
